export default "__VITE_PUBLIC_ASSET__e5448fa3__"